<template>
  <div>
    <div class="lighten-5">
      <router-view></router-view>
    </div>
    <v-container>
      <v-row>
        <v-col class="pb-0" v-for="item in items" :key="item.id" cols="12">
          <v-card
            flat
            :to="
              loggedIn
                ? { name: 'ItemDetail', params: { id: item.id } }
                : undefined
            "
          >
            <v-row>
              <v-col cols="12" sm="6">
                <v-card-title
                  class="pt-0 pb-0 headline"
                  style="word-break: normal;"
                  >{{ item.term }}</v-card-title
                >
              </v-col>
              <v-col cols="12" sm="6">
                <v-card-title
                  class="pt-0 pb-0 headline text--secondary"
                  style="word-break: normal;"
                  >{{ item.meaning }}
                </v-card-title>
              </v-col>
            </v-row>
            <div v-for="example in item.examples" :key="example.id">
              <v-row>
                <v-col cols="12" sm="6">
                  <v-card-text class="pt-0 pb-0 text--secondary">
                    {{ example.content }}
                  </v-card-text>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-card-text class="pt-0 pb-0 text--secondary">
                    {{ example.description }}
                  </v-card-text>
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-col>
        <v-col v-if="loggedIn" :key="'__newitem__'" cols="12">
          <v-btn
            v-if="items.length == 0"
            min-height="5rem"
            height="100%"
            depressed
            block
            large
            @click="newItem"
            color="primary"
            outlined
          >
            <v-icon>mdi-plus</v-icon> Add term
          </v-btn>
          <div
            v-if="items.length > 0"
            style="position: fixed; bottom: 160px; right: 10px; z-index: 4;"
          >
            <v-btn
              dark
              absolute
              color="primary"
              right
              fab
              @click="newItem"
              style="width: fit-content; border-radius: 100px; padding: 16px;"
            >
              <v-icon>mdi-plus</v-icon> Add term
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="showAddItemDialog" max-width="800px">
      <AddItem studyList="editStudyList" v-bind:onFinish="closeAddItemDialog" />
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import AddItem from "@/components/AddItem.vue";

export default {
  name: "StudyListDetail",
  props: {
    id: {
      required: true,
    },
  },
  data: () => ({
    showAddItemDialog: false,
  }),

  beforeRouteEnter(to, _, next) {
    Promise.all([
      store.dispatch("fetchStudyList", to.params.id),
      store.dispatch("fetchItems", to.params.id),
    ]).then(() => {
      next();
    });
  },

  computed: mapGetters(["studyList", "items", "loggedIn"]),

  methods: {
    newItem() {
      this.showAddItemDialog = true;
    },
    closeAddItemDialog() {
      this.showAddItemDialog = false;
    },
  },

  components: {
    AddItem,
  },
};
</script>
